import React from "react";


const FooterPanel = ({imgUrl, imgStyle, title, description, buttonText, onButtonClick}) => {
    return (
        <div className='calculator-footer-panel'>
            <div style={{
                width: '64px',
                height: '64px',
                border: '1px solid var(--primary-color)',
                borderRadius: '50%',
                background: '#ffffff',
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: '1rem',
            }}>
                <img src={imgUrl}
                     alt="CO2"
                     style={imgStyle}
                />
            </div>
            <p
                className='font-md'
                style={{textAlign: 'center', fontSize: '12px', fontWeight: 700}}
            >
                {title}
            </p>
            <p
                style={{textAlign: 'center', fontSize: '11px', fontWeight: 400}}
            >
                {description}
            </p>
            <button className="mt-2 btn btn-primary" onClick={() => {onButtonClick()}}>
                {buttonText}
            </button>
        </div>
    )
};

export default FooterPanel;